// components/NsfwImage.tsx
"use client";
import { useState } from "react";
import { Image, Button, Flex, Text } from "@chakra-ui/react";

const NsfwImage = ({
  src,
  alt,
  nsfw,
  onClick,
  ...rest
}: {
  src: string;
  alt: string;
  nsfw?: boolean | null;
  onClick?: () => any;
}) => {
  const [isBlurred, setIsBlurred] = useState(nsfw);

  const handleToggleBlur = () => {
    setIsBlurred(!isBlurred);
  };

  return (
    <Flex direction="column" align="center" position="relative" {...rest}>
      <Image
        src={src}
        alt={alt}
        borderRadius="14px"
        objectFit="cover"
        filter={isBlurred ? "blur(15px)" : "none"}
        cursor="pointer"
        boxShadow={isBlurred ? "0 0 2px 5px rgb(44, 49, 77)" : ""}
        maxWidth="100%"
        onClick={() => (onClick && !isBlurred ? onClick() : console.log(""))}
      />
      {isBlurred && (
        <Button
          position="absolute"
          bottom="10px"
          bg="rgba(0,0,0,0.2)"
          borderRadius="15px"
          border="1px solid black"
          onClick={(e) => {
            handleToggleBlur(), e.stopPropagation();
          }}
          _hover={{ color: "white", bg: "rgba(0,0,0,0.4)" }}
        >
          <Text color="white">Click to view</Text>
        </Button>
      )}
    </Flex>
  );
};

export default NsfwImage;
